module.exports = __webpack_public_path__ + "media/images/logo/fcr-1842c3a92db0ca0e4762bb34944800a6.svg";